export const replaceIframeDimensions = (
  inputString: string,
  windowSize: number,
) => {
  // 正規表現を使用して<iframe>タグを見つけ、widthとheight属性を置換
  return inputString.replaceAll(/<iframe[^>]*>/g, (iframeTag) => {
    // Width属性を置換
    let newIframeTag = iframeTag.replace(
      /width="\d+"/,
      `width="${(windowSize - 80).toString()}"`,
    );
    // Height属性を置換
    newIframeTag = newIframeTag.replace(
      /height="\d+"/,
      `height="${(((windowSize - 80) / 560) * 315).toString()}"`,
    );
    return newIframeTag;
  });
};
